module.exports = __webpack_public_path__ + "static/media/referralOff_118.9a2d945d.png";